import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { tokens } from '../theme';

// The quiet button (Close, Cancel): looks like the theme's outlined buttons whatever variant it is given
const GreyButton = styled(Button)(() => ({
    backgroundColor: tokens.surface,
    color: tokens.ink,
    border: `1px solid ${tokens.borderControl}`,
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: tokens.surfaceHover,
        boxShadow: 'none',
    }
}));

export default GreyButton;
